import React from 'react';
import { Box, Grow, Modal } from '@mui/material';
import classes from './SuccessMessageModal.module.css';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useNavigate } from 'react-router-dom';
import { TVPagePostsGet } from '../../../../../Store/TVPagePostsSlice';
import { useDispatch } from 'react-redux';

export default function SuccessMessageModal(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  setTimeout(() => {
    props.setSuccessMessageModal(false);
    navigate('/');
    dispatch(TVPagePostsGet());
  }, 2000);
  const handleClose = () => {
    props.setSuccessMessageModal(false);
    dispatch(TVPagePostsGet());
    navigate('/');
  };

  return (
    <Modal open={true} onClose={handleClose}>
      <div>
        <Grow in={true}>
          <Box className={classes.SuccessMessageModal}>
            <Box className={classes.SuccessMessageModalBox}>
              <CheckCircleRoundedIcon className={classes.checkCircle} />
              <p className={classes.SuccessMessageModalText}>
                Creative Interest has been successfully updated.
              </p>
            </Box>
          </Box>
        </Grow>
      </div>
    </Modal>
  );
}
